//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    width: {
      type: String,
      default: '400'
    },
    height: {
      type: String,
      default: '280'
    },
    siteName: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '35'
    },
    // margin-top的值
    iconfont: {
      type: String,
      default: ''
    }
  }
};